import { createContext, useContext } from 'react'
import type { ChatLoadingState } from 'tripPlanner/assistant/runtime/chatStream'

export interface ChatStreamStatusValue {
  chatId: number | undefined
  chatKey: string
  isStreaming: boolean
  isStreamOpen: boolean
  isAwaitingMessageEnd: boolean
  loadingState: ChatLoadingState
  streamError: Error | undefined
  /** True when the stream is active but no chunks have arrived for 10+ seconds. */
  isStalled: boolean
  /** navigator.onLine — false when device has no network connection. */
  isOnline: boolean
  /** Cycling summary messages from Groq for the reasoning phase. Empty if Groq failed. */
  reasoningSummaries: ReadonlyArray<string>
  /** Current tool call info for the tool_calling phase. */
  toolCallInfo: { tool: string; args: Record<string, unknown> } | undefined
}

export const ChatStreamStatusContext = createContext<ChatStreamStatusValue | undefined>(undefined)

export function useChatStreamStatus(): ChatStreamStatusValue {
  const ctx = useContext(ChatStreamStatusContext)
  if (!ctx) throw new Error('useChatStreamStatus must be used within a chat stream status provider')
  return ctx
}
